import "../ws8/ws8.css";
import { ChooseView } from "../ws8/choose/ChooseView";

/** Choose (/choose): Tinder-style template chooser. Owned by WS8 (implementation in web/src/ws8/choose). */
export function ChoosePage() {
  return <ChooseView />;
}
